/**
 * The customer portal's history floor — orders before this date are not
 * reachable through the portal at all (`docs/features/customer-storefront/
 * 05_views_module_update_spec.md` §3/§11 invariant 5: history starts at the
 * LIVE Tharstern cutover and is clamped there in SQL, not just in the UI).
 *
 * A real, permanent business constant — not journey-iteration scaffolding —
 * so it lives here rather than in mock-data, and both the mock and real
 * adapters' pages read it from the same place.
 */
export const HISTORY_FLOOR_ISO = "2025-06-03";
export const HISTORY_FLOOR_LABEL = "June 2025";
